/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_SkillgroupInputs */

const en_entity_skillgroup = /** @type {(inputs: Entity_SkillgroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill Group`)
};

const de_entity_skillgroup = /** @type {(inputs: Entity_SkillgroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skillgruppe`)
};

/**
* | output |
* | --- |
* | "Skill Group" |
*
* @param {Entity_SkillgroupInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_skillgroup = /** @type {((inputs?: Entity_SkillgroupInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_SkillgroupInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_skillgroup(inputs)
	return de_entity_skillgroup(inputs)
});